import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';



Snappy.Component.CommentsCount = class CommentsCount extends Snappy.BaseComponent {
    static get tagName() {
        return 'comments-count';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.getComments();
    }

    setVars() {
        this.$document = $(document);
        this.$wrappers = this.$element.find('.js-comments-count-wrapper');
        this.endPoint = this.$element.data('commentsCountUrl');
    }


    getComments() {
        const paramArray =[];
        this.$wrappers.each((i, item) => {
            const contentId= $(item).data('contentId');
            if (contentId) {
                paramArray.push('postsIds='+contentId);
            }
        });
        if (!paramArray.length) {
            return;
        }

        const parameters = paramArray.join('&');
        const qs = `${this.endPoint}?${parameters}`;
        $.get(qs, (data)=> {
            if (data.success) {
                this.renderCount(data.result);
            }
        });
    }

    renderCount(countArr) {
        countArr.forEach((item) => {
            if (item.commentsCount > 0) {
                const $currentWrapper = this.$wrappers.filter(`[data-content-id="${item.contentId}"]`);
                const $count = $currentWrapper.find('.js-comments-count-el');
                $currentWrapper.show();
                $count.text(item.commentsCount);
            }
        })
    }
};



// WEBPACK FOOTER //
// ./components/comments-count/scripts/comments-count.js